import { Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow,ToggleButton, Typography, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PlaceService from "../../../Services/place/PlaceService";
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.white,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function ClearanceLoc() {
  const mystyle = {
    border: " 1px solid black",
    fontFamily: 'Times New Roman',
    width: "12rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    fontFamily: 'Times New Roman',
    color: "red",
  };
  const mystyle2 = {
    fontWeight: "bolder",
    fontFamily: 'Times New Roman',
    color: "#0b64c5",
  };
  const [values, setvalues] = useState({
    clrId: '', name: '', code: '', year: '',
    logo: '', address: '', phone: '', pointId: '',
    web: '', mail: '', tin: '', pan: '',
  });

  const [saveDsa, setSaveDsa] = useState(false);
  const [updateDsa, setUpdateDsa] = useState(true);
  const [deleteDsa, setDeleteDsa] = useState(true);

  const [Deletes, setDelete] = useState(false);
  const [save, setSave] = useState(false);
  const [update, setUpdate] = useState(false);

  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [clrDetails, setClrDetails] = useState([]);

  const [error, setError] = useState({
    name: false, code: false, yearEstablishment: false
  })

  const namehandlechange = (e) => {
    setvalues({ ...values, name: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const codehandlechange = (e) => {
    setvalues({ ...values, code: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const yearhandlechange = (e) => {
    setvalues({ ...values, year: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const logohandlechange = (e) => {
    setvalues({ ...values, logo: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') });
  };
  const addresshandlechange = (e) => {
    setvalues({ ...values, address: e.target.value.replace(/[`~!@#$%^*()_|+\-{}=[?;:'"<>]/gi, '') });
  };
  const phonehandlechange = (e) => {
    setvalues({ ...values, phone: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const webhandlechange = (e) => {
    setvalues({ ...values, web: e.target.value.replace(/[`~!#$%^&*()_|+\-{}=[?;:'",<>]/gi, '') });
  };
  const mailhandlechange = (e) => {
    setvalues({ ...values, mail: e.target.value.replace(/[`~!#$%^&*()_|+\-{}=[?;:'",<>]/gi, '') });
  };
  const tinhandlechange = (e) => {
    setvalues({ ...values, tin: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };
  const panhandlechange = (e) => {
    setvalues({ ...values, pan: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
  };

  //getdata

  const getData = async () => {
    PlaceService.getOrganization().then((res) => {
      setClrDetails(res.data);
    })
  }

  useEffect(() => {
    getData();
  }, []);

  //tableClick
  const editClrDetails = (item) => {
    setSaveDsa(true);
    setUpdateDsa(false);
    setDeleteDsa(false);
    setSave(false);
    setUpdate(false);
    setDelete(false);
    setvalues({
      ...values, pointId: item.pointId, clrId: item.organizationId, name: item.organizationName, address: item.address, code: item.organizationCode,
      logo: item.organizationLogo, mail: item.mailId, pan: item.panNumber, phone: item.phoneNumber, tin: item.tinNumber, web: item.website,
      year: item.yearOfEstablishment
    });
  }

  //handlClose/open

  const handleClose = () => {
    setOpen(false);
  }

  //clickEvent

  const validate = () => {
    if (values.name !== '') {
      if (values.code) {
        if (values.year) {
          return true;
        } else {
          document.getElementById('yearofEstablisment').focus();
          setError({ ...error, yearEstablishment: true });
          setOpen(true); setSeverity('warning'); setMessage('please Enter a YearOfEstablished')
        }
      } else {
        document.getElementById('code').focus();
        setError({ ...error, code: true });
        setOpen(true); setSeverity('warning'); setMessage('please Enter a Code')
      }
    } else {
      document.getElementById('name').focus();
      setError({ ...error, name: true });
      setOpen(true); setSeverity('warning'); setMessage('please Enter a Name')
    }
    return false;
  }

  const saveClr = () => {
    if (validate() === true) {
      setSaveDsa(true);
      setSave(true);
      let details = {
        organizationName: values.name, organizationCode: values.code, address: values.address, phoneNumber: values.phone,
        website: values.web, mailId: values.mail, tinNumber: values.tin, panNumber: values.pan, yearOfEstablishment: values.year,
      }
      PlaceService.insertOrganizationName(details).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }

  const updateClrDetails = () => {
    if (validate() === true) {
      if (values.pointId !== '') {
        setUpdateDsa(true);
        setUpdate(true);
        let details = {
          pointId: values.pointId,
          organizationName: values.name, organizationCode: values.code, address: values.address, phoneNumber: values.phone,
          website: values.web, mailId: values.mail, tinNumber: values.tin, panNumber: values.pan, yearOfEstablishment: values.year,
        }
        PlaceService.updateOrganizationName(details).then((res) => {
          const message = res.data.message;
          if (message.toString() === 'SUCCESS') {
            setOpen(true); setSeverity('success'); setMessage(message);
          } else {
            setOpen(true); setSeverity('error'); setMessage('Updation Failed');
          } refresh();
        }).catch(error => {
          setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
        })
      } else {
        setOpen(true); setSeverity('warning'); setMessage('please select Clearance Organization..!'); refresh();
      }
    }
  }

  const deleteClrDetails = () => {
    if (values.pointId !== '') {
      setDeleteDsa(true);
      setDelete(true);
      PlaceService.deleteOrganizationName(values.pointId).then((res) => {
        const message = res.data.message;
        if (message.toString() === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
        } refresh();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    } else {
      setOpen(true); setSeverity('warning'); setMessage('please select Clearance Organization..!'); refresh();
    }
  }

  const refresh = () => {
    setPage(0)
    setSaveDsa(false);
    setUpdateDsa(true);
    setDeleteDsa(true);
    setSave(false);
    setUpdate(false);
    setDelete(false);
    setvalues({
      ...values, clrId: '', name: '', address: '', code: '', pointId: '',
      logo: '', mail: '', pan: '', phone: '', tin: '', web: '', year: ''
    });
    setError({ ...error, name: false, code: false, yearEstablishment: false });
    getData();
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  
  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/State');
  }
  const ForwordBotton =()=>{
    navigate('/Chargetype');
  }
  return (
    <div>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
            {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> 
            <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }}/> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}style={{ fontFamily: 'Times New Roman'}}>
                Clearance Location Entry
              </Typography>
              </Col>
              </Row>
              <hr></hr>
              <Row className="mt-2">
                <Col xs={4}>
                  <label style={mystyle1}>Name*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} isInvalid={error.name}
                    value={values.name} onChange={namehandlechange} id='name' />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle1}>Code*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} isInvalid={error.code}
                    value={values.code} onChange={codehandlechange} id='code' />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle1}>YearEstb*</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} isInvalid={error.yearEstablishment}
                    value={values.year} onChange={yearhandlechange} id='yearofEstablisment' />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>Logo</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle}
                    value={values.logo} onChange={logohandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>Address</label>
                </Col>
                <Col xs={8}>
                  <Form.Control rows={3} as={'textarea'} size="sm" style={mystyle}
                    value={values.address} onChange={addresshandlechange} className='scrollbarPrime' />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>PhoneNo</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="tel" style={mystyle} value={values.phone}
                    onChange={phonehandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>Website</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle}
                    value={values.web} onChange={webhandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>MailID</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle}
                    value={values.mail} onChange={mailhandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>Tin No</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle}
                    value={values.tin} onChange={tinhandlechange} />
                </Col>
              </Row>
              <Row className="mt-1">
                <Col xs={4}>
                  <label style={mystyle2}>PAN No</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={values.pan} onChange={panhandlechange} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button variant="success" size="sm"style={{ fontFamily: 'Times New Roman'}} disabled={saveDsa} onClick={saveClr}>
                    {save ? 'processing..' : 'Save'}
                  </Button>
                  &nbsp;
                  <Button variant="primary" size="sm"style={{ fontFamily: 'Times New Roman'}} disabled={updateDsa} onClick={updateClrDetails}>
                    {update ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button variant="danger" size="sm"style={{ fontFamily: 'Times New Roman'}} disabled={deleteDsa} onClick={deleteClrDetails}>
                    {Deletes ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button variant="secondary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={refresh}>
                    refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
                <Row>
                  <Col xs={11}></Col>
                  {/* <Col xs={1}>  <ToggleButton onClick={ForwordBotton} size="small" className='headerstyleEND'> 
                  <ArrowForwardIosIcon fontSize="small"  style={{ fontSize: '16px'}} /> </ToggleButton> </Col> */}
                </Row>
                <TableContainer sx={{ height: 360 }} style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell>SlNo</StyledTableCell>
                        <StyledTableCell>Clearance OrgName</StyledTableCell>
                        <StyledTableCell>Clearance OrgCode</StyledTableCell>
                        <StyledTableCell>PhoneNumber</StyledTableCell>
                        <StyledTableCell>Address</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                    {clrDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                        <StyledTableRow hover key={item.organizationId} onClick={() => editClrDetails(item)}>
                          <StyledTableCell>{item.serialNumber}</StyledTableCell>
                          <StyledTableCell>{item.organizationName}</StyledTableCell>
                          <StyledTableCell>{item.organizationCode}</StyledTableCell>
                          <StyledTableCell>{item.phoneNumber}</StyledTableCell>
                          <StyledTableCell>{item.address}</StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={clrDetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default ClearanceLoc;
